import fly from '../utils/http.js'
import qs from 'qs'
// 发布商品
export const createGoods = (params) => {
  return fly.post('/goods/create', params)
}
// 图片上传
export const upload = (params) => {
  return fly.post('/file/upload', params)
}
// 首页推荐
export const getRecommendGoodsList = (params) => {
  return fly.get('/goods/getRecommendGoodsList', qs.stringify(params))
}
// 商品列表
export const getGoodsList = (params) => {
  return fly.get('/goods/searchGoods', qs.stringify(params))
}
// 广告列表
export const getAdList = (params) => {
  return fly.get('/ad/getAdList', qs.stringify(params))
}

// 商品详情
export const getGoodsDetail = (params) => {
  return fly.get('/goods/'+params)
}

//获取wx签名
export const shareSign= (params) => {
  return fly.get("/weixin/getShareSign" ,qs.stringify(params))
}
